import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Container,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  CardContent,
} from '@mui/material';

const Instafeed = () => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const ACCESS_TOKEN = "IGAAiTjZCp6PitBZAE9VWlRkRGZAaVV9UdC1ndnd4cURuWGFabE5oeUhTV2pvajFhbURGN1ZAaZAFRERDU3ZAHVad3NpdEFaOTktM1YyQ21NUGNueVEwN1lKWlNrelFWWW9sWkJFMGIzQ29jN2NDYkxDcVREYm5CMkt3amtSRjYzTGItSQZDZD"; // Replace with your token


      try {
        const response = await axios.get(
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&access_token=${ACCESS_TOKEN}`
        );
        const latestPosts = response.data.data.slice(0, 3);
        setPosts(latestPosts);
      } catch (error) {
        console.error('Error fetching Instagram posts', error);
        setError('Kunde inte ladda Instagramflödet.');
      }
    };

    fetchPosts();
  }, []);

  return (
    <Box sx={{ background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)', py: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.5rem' },
            color: '#222',
            mb: 6,
          }}
        >
          Senaste från Instagram
        </Typography>

        {error ? (
          <Typography align="center" sx={{ color: '#f00', mb: 4 }}>
            {error}
          </Typography>
        ) : (
          <Grid container spacing={4} justifyContent="center">
            {posts.map((post) => (
              <Grid item xs={12} sm={6} md={4} key={post.id}>
                <Card
                  sx={{
                    background: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(6px)',
                    borderRadius: '1rem',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    overflow: 'hidden',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
                    },
                  }}
                >
                  <CardActionArea
                    href={post.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM' ? (
                      <CardMedia
                        component="img"
                        height="300"
                        image={post.media_url}
                        alt={post.caption}
                        sx={{ objectFit: 'cover' }}
                        loading="lazy"
                      />
                    ) : post.media_type === 'VIDEO' ? (
                      <CardMedia
                        component="video"
                        controls
                        height="300"
                        src={post.media_url}
                        sx={{ objectFit: 'cover' }}
                      />
                    ) : null}

                    {post.caption && (
                      <CardContent
                        sx={{
                          px: 3,
                          py: 2,
                          backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          backdropFilter: 'blur(3px)',
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#444',
                            fontSize: '0.95rem',
                            lineHeight: 1.5,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {post.caption.split('\n')[0]}
                        </Typography>
                      </CardContent>
                    )}
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default Instafeed;
